import 'jquery-validation';


export default {
    init() {

    
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if(iOS){
        $('.vid-container').remove();
        $('.image-hero img').removeClass('d-none');
    }   

    //toggle class targer
    $('[data-toggle-class]').click(function(ev){
        ev.preventDefault();
        $($(this).attr('data-target')).toggleClass($(this).attr('data-toggle-class'));
        var el = this
        setTimeout(function(){      
        $('body').toggleClass('toggled-'+$(el).attr('data-toggle-class'));
        },200)
    }); 


    //submenu open
    $('.nav-primary li:eq(1)').hover( function() {
        //$('.sub-menu-collection').addClass('open-sub-menu');
        $('.banner').addClass('delay-banner');
        if($('.sub-menu-collection').hasClass('open-sub-menu') ) {
            $('.banner').mouseleave( function() {
                $('.sub-menu-collection').removeClass('open-sub-menu');
            });
            $('.nav li a').not(this).hover( function() {
                $('.sub-menu-collection').removeClass('open-sub-menu');
            });
        }
        $('.banner').mouseenter( function() {
            if($('.banner').hasClass('delay-banner')){
                $('.banner').removeClass('delay-banner');
            }
        });
    });


    var sub = [1,2];

    $.each(sub, function(i,v){
        $('.nav-primary li').eq(v).hover( function(){
            // console.log('hover'+i)
            $('.sub-menu-collection').eq(i).addClass('open-sub-menu');
        })
    })





    //bolder sub menu

    $('.list-collection li:first-child a').addClass('bold');

    $('.image-slider').on('afterChange',function(event,slick,currentSlide){
        $('.list-collection li a').removeClass('bold');
        $('.list-collection li:nth-child('+ (parseInt(currentSlide) + 1) +') a').addClass('bold');
    });


    //var menuItemLength  = $('.list-collection li').length;

    //slider sub menu

    $('.image-slider-0').slick({
        dots: false,
        arrows: true,
        nextArrow: $('.next-slide'),
        prevArrow: false,
        infinite: true,
        speed: 300,
        //slidesToShow: 4,
        draggable: false,
        variableWidth: true,
        //slidesToScroll: 1,
        // centerMode: true,
    });

    $('#asd0').slick({
        dots: false,
        arrows: true,
        nextArrow: $('#sub-0 .next-slide'),
        prevArrow: false,
        infinite: true,
        speed: 300,
        //slidesToShow: 5,
        draggable: true,
        variableWidth: true,
        slidesToScroll: 1,
        // centerMode: true,
    });

    $('#asd1').slick({
        dots: false,
        arrows: true,
        nextArrow: $('#sub-1 .next-slide'),
        prevArrow: false,
        infinite: true,
        speed: 300,
        //slidesToShow: 4,
        draggable: true,
        variableWidth: true,
        //slidesToScroll: 1,
        // centerMode: true,
    });



    //on image hoveg text bold

    var beforeActiveIndex = null;
    $('.slick-slide').hover(function(){
        const menuItemLength = $(this).parents('.menu-prod-wrapper').find('.list-collection li').length;
        console.log(menuItemLength)
        var index = $(this).index() % menuItemLength ? $(this).index() % menuItemLength : menuItemLength ;
        beforeActiveIndex = $('.list-collection li a.bold').parent().index();
        $('.list-collection li a').removeClass('bold');
        $('.list-collection li:nth-child('+ (parseInt(index)) +') a').addClass('bold');
    },function(){
        $('.list-collection li a').removeClass('bold');
        $('.list-collection li:nth-child('+ beforeActiveIndex + 1 +') a').addClass('bold');
    })


    //on text hover go to image

    var timeout = null;
    $('.list-collection li').hover(function(){
        const menuItemLength = $(this).parent().find('li').length;
        var index = $(this).index() % menuItemLength ? $(this).index() % menuItemLength : menuItemLength ;
        $('.list-collection li a').removeClass('bold');
        $('.list-collection li:nth-child('+ (parseInt(index) +1) +') a').addClass('bold');
        if (timeout !== null){
            clearTimeout(timeout);
        }
        timeout = setTimeout(function(){
            $('.image-slider').slick('slickGoTo',index);
            timeout = null;
        },400);       
    }); 


    //cookie banner

    if ( ! window.localStorage.getItem('dbassanesi-cookie-banener') ){
      $('.cookie-banner').removeClass('d-none');
    }

    $('[data-toggle-class="close-cookie"]').click(function(){
      $('.cookie-banner').addClass('d-none');
      window.localStorage.setItem('dbassanesi-cookie-banener','accepted');
    })


    document.body.classList.add('js-loading');

    window.addEventListener('load', showPage);

    function showPage() {
        document.body.classList.remove('js-loading');
    }

    // chance bg color
        var breakpoints = [];
        function valorizeBreakpoints(){
            $('.db-change-bg').each(function(){
                var $item = $(this);
                var val = $item.offset().top;
                if ( $item.data('offset') !== undefined ){
                    val = val + $(window).height() * parseFloat($item.data('offset') / 100);
                }
                // console.log($(window).height() * parseFloat($item.data('offset') / 100),val)
                breakpoints.push( {
                    val,
                    header: $item.data('change-header') !== undefined,
                    color : $item.data('color'),
                });
            });
        }

        //Da commentare il setTimeout (ma non valorizeBreakpoints() )

        var timeoutLocalhost =  window.origin.indexOf('localhost') >= 0 ? 2000 : 0;
        setTimeout(function(){
            valorizeBreakpoints();
        },timeoutLocalhost);   


        $(window).resize(valorizeBreakpoints);
        // var activeClass = null;
        var activeColor = null;

        function scrollCommonEvents(){
            var color = '';
            var updateHeader = '';
            breakpoints.forEach(function(breakpoint){
                // console.log('check scroll',$(window).scrollTop())
                // console.log('check breakpoint', breakpoint.class , breakpoint.val,$(window).scrollTop())
                if ($(window).scrollTop() > breakpoint.val) {
                    // className = breakpoint.class;
                    color = breakpoint.color;
                    updateHeader = breakpoint.header;
                }
            });
            // if (activeClass != className){
            //  $('body').removeClass(activeClass);
            //  activeClass = className;
            //  $('body').addClass(activeClass);
            // } 

            if (activeColor != color){
                // $('body').style({
                //  'background-color' : '';
                // });
                activeColor = color;
                $('#modular-blocks').css({
                    'background-color' : activeColor,
                });
                if (updateHeader){
                    $('.banner').css({
                        'background-color' : activeColor,
                    });
                }else{
                    $('.banner').css({
                        'background-color' : '',
                    });
                }

            } 

            if ($(window).scrollTop() > 1) {
                $('.banner').addClass('tiny-menu');
            }
            if ($(window).scrollTop() < 1) {
                $('.banner').removeClass('tiny-menu');
            }
        }

        scrollCommonEvents()
        $(window).scroll(scrollCommonEvents);

        $('[data-modal-download]').click(function(){
            const $this = $(this);
            var filneme = $this.data('modal-download');
            var url = $this.attr('href');
            $('input[name="download-file-name"]').val(filneme);
            $('input[name="download-file-url"]').val(url);
        });


        $('.nl-form').each(function(){
            var privacyCheck = $(this).find('#privacy_check');
            var txtNormal = privacyCheck.parent().find('.text-white.small').html();
            var messagePrivacy = $('html').attr('lang') === 'it-IT' ? 'Checkbox obbligatoria' : 'Mandatory checkbox';
            var cityreuired = $(this).find('input#city').length > 0;
            var professionreuired = $(this).find('input#profession').length > 0;
            $(this).validate({
              rules: {
                name: {
                  required: true,
                },
                surname: {
                  required: true,
                },
                email: {
                  required: true,
                  email: true,
                },
                privacy_check: {
                  required: true,
                },
                city: {
                    required: cityreuired,
                },
                profession: {
                    required: professionreuired,
                },
              },
              messages: {
                name: {
                  required: $('#name').data('error-message'),
                },
                surname: {
                  required: $('#surname').data('error-message'),
                },
                email: {
                  required: $('#email').data('error-message'),
                  email: $('#email').data('error-message'),
                },
                privacy_check: {
                  required: $('#privacy_check').data('error-message'),
                },
              },
              // grecaptcha.ready(function() {
              submitHandler: function(form,e ) {
                e.preventDefault();
                if (! privacyCheck.prop('checked') == true){
                    privacyCheck.parent().find('.text-white.small').html(`${txtNormal} - ${messagePrivacy}`);
                    return false;
                }else{
                    privacyCheck.parent().find('.text-white.small').html(txtNormal);
                }
                $(form).parent().addClass('loading');
                      $.post({
                        data: $(form).serialize(),
                        url: window.origin+'/wp-json/boom-decoratori/v1/mailing',
                        success: function(data) {
                            if (data.status == 'ok'){ 

                            $(form).parent().removeClass('loading');
                            $(form).parent().addClass('completed');

                            $(form)[0].reset();
                            }else{
                            // alert(data.message);
                            }
                        },
                        error: function() {
                            $(form).parent().removeClass('loading');
                            $(form).parent().addClass('error');
                        },
                    });
              },
            })
        });
    },
    finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js